import { render } from "./ViewShared.vue?vue&type=template&id=28c2d5d8"
import script from "./ViewShared.vue?vue&type=script&lang=js"
export * from "./ViewShared.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__